import { ComponentProps, useEffect, useRef } from "react";
import cx from "classnames";

export const DynamicScaling = ({
  children,
  className,
  ...props
}: ComponentProps<"div">) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const fakeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current,
      content = contentRef.current,
      fake = fakeRef.current;
    if (!container || !content || !fake) return;

    const checkSize = () => {
      const containerWidth = container.clientWidth;
      const actualWidth = container.scrollWidth;

      if (actualWidth > containerWidth) {
        const scaleTo = containerWidth / actualWidth;
        content.style.zoom = `${scaleTo}`;
      } else {
        content.style.zoom = "";
      }
    };

    window.addEventListener("resize", checkSize);

    const resizeObserver = new ResizeObserver((entries) =>
      entries.forEach(checkSize)
    );

    resizeObserver.observe(fake);

    checkSize();

    return () => {
      window.removeEventListener("resize", checkSize);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      className={cx(
        "max-w-full w-full break-keep whitespace-nowrap",
        className
      )}
      {...props}
    >
      <div className="w-full max-w-full relative" ref={containerRef}>
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2"
          ref={contentRef}
        >
          {children}
        </div>
        <div className="invisible select-none" ref={fakeRef}>
          {children}
        </div>
      </div>
    </div>
  );
};
